exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.min-w7[data-v-6fc60636] {\n  min-width: 55rem;\n}\n.min-h7[data-v-6fc60636] {\n  min-height: 30rem;\n}\n.custom-height[data-v-6fc60636] {\n  max-height: 350px;\n  overflow-x: hidden;\n}\n", ""]);

// exports
